import type { HTMLAttributes, ReactNode } from 'react'
import { cx } from './utils'

export function Card({ className, ...props }: HTMLAttributes<HTMLElement>) {
  return <article className={cx('card', className)} {...props} />
}

export function CardStatus({ label, tone = 'neutral' }: { label: string; tone?: 'neutral' | 'accent' | 'warning' }) {
  return <span className={cx('card__status', `card__status--${tone}`)}>{label}</span>
}

export function CardBody({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="card__body">
      <h3 className="card__title">{title}</h3>
      <div className="card__copy">{children}</div>
    </div>
  )
}
